/**
 * Confidence Badge Component - Displays confidence score with color coding
 */

import React from 'react';
import { Chip, Tooltip, Box } from '@mui/material';
import { getConfidenceInfo, formatConfidence, getConfidenceDescription } from '@/utils/confidence';

interface ConfidenceBadgeProps {
  score: number;
  size?: 'small' | 'medium';
  showLabel?: boolean;
}

const ConfidenceBadge: React.FC<ConfidenceBadgeProps> = ({
  score,
  size = 'medium',
  showLabel = true,
}) => {
  const info = getConfidenceInfo(score);
  const description = getConfidenceDescription(score);
  const formattedScore = formatConfidence(score);

  const label = showLabel ? `${info.label}: ${formattedScore}` : formattedScore;

  return (
    <Tooltip title={description} arrow>
      <Chip
        label={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <span>{info.icon}</span>
            <span>{label}</span>
          </Box>
        }
        size={size}
        sx={{
          backgroundColor: info.color,
          color: info.level === 'high' ? '#000' : '#fff',
          fontWeight: 600,
          '&:hover': {
            backgroundColor: info.color,
            opacity: 0.9,
          },
        }}
      />
    </Tooltip>
  );
};

export default ConfidenceBadge;
